export default __webpack_public_path__ + "static/media/github2.9e094d23.png";